
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmsGatewaySettingsGrid extends Serenity.EntityGrid<SmsGatewaySettingsRow, any> {
        protected getColumnsKey() { return SmsGatewaySettingsColumns.columnsKey; }
        protected getDialogType() { return SmsGatewaySettingsDialog; }
        protected getIdProperty() { return SmsGatewaySettingsRow.idProperty; }
        protected getInsertPermission() { return SmsGatewaySettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return SmsGatewaySettingsRow.localTextPrefix; }
        protected getService() { return SmsGatewaySettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}